import { Component, Inject, OnInit } from '@angular/core';
import { TLK_MODAL_WINDOW_DATA } from '@itero/ui-toolkit-angular/modal-window';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PatientAppIframeId } from '@shared/models/enums/patient-app-iframe-id.enum';
import { PatientAppPupupInput } from '@modules/patient/models/patient-app-pupup-input';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';

@Component({
	selector: 'rx-patient-popup-app',
	templateUrl: './patient-app-popup.component.html',
	styleUrls: ['./patient-app-popup.component.scss']
})
export class PatientAppPopUpComponent implements OnInit {
	editPatientAppUrl: SafeResourceUrl;
	searchPatientAppUrl: SafeResourceUrl;
	patientAppId = PatientAppIframeId;

	constructor(
		@Inject(TLK_MODAL_WINDOW_DATA) public dialogInput: PatientAppPupupInput,
		private sanitizer: DomSanitizer
	) {
	}

	ngOnInit(): void {
		if (this.dialogInput?.editPatientAppUrl) {
			this.editPatientAppUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dialogInput?.editPatientAppUrl);
		}
		if (this.dialogInput?.searchPatientAppUrl) {
			this.searchPatientAppUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dialogInput?.searchPatientAppUrl);
		}
	}

}
